<dsd-container padding="none">
  <div id="intro-wrapper">
    <div class="info-container dsd-p-md">
      <h1 id="titreFinParcours" tabindex="-1" class="dsd-t-3 dsd-mb-md">
        {{ 'finParcours.titre' | translate }}
      </h1>
      <p>{{ 'finParcours.description' | translate }}</p>

      <app-contactez-nous niveauTitre="h2"></app-contactez-nous>
    </div>
    <div class="img-container" aria-hidden="true">
      <img
        alt=""
        class="img"
        src="{{ 'assets/img/img-fin-parcours.png' | cheminAbsoluStatique }}"
      />
    </div>
  </div>
</dsd-container>

<app-bouton-retour></app-bouton-retour>
